<div>
    <img alt="BeCare" src="{{becareconfig.becarelogo}}">
    <div class="serverdate">{{serverdate}}</div>
    <div class="servertime">{{servertime}}</div>
</div>
